module.exports = __webpack_public_path__ + "static/media/production_comparative_per_day.073c40e0.svg";